export default {
  API_URL: 'https://qbe-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://qbesandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
